import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as d3 from 'd3';
import html2canvas from 'html2canvas';
import { CONFIG } from "../config";

export default function VehicleAiRecommendations({ vehicleId, selectedDate }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Format date to MM/DD/YYYY for backend
  const formatDate = (date) => {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  // Capture screenshot and send to FastAPI
  const captureAndSendScreenshot = async () => {
    try {
      const canvas = await html2canvas(document.body, {
        scrollY: -window.scrollY,
        windowHeight: document.body.scrollHeight,
      });

      const imageBase64 = canvas.toDataURL("image/png");

      const response = await fetch(`${CONFIG.API_BASE_URL}/${CONFIG.VEHICLE_AI_RECOMMENDATIONS_URL}/${localStorage.getItem("tensor-user-id")}/${vehicleId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tensor-auth-token"),
        },
        body: JSON.stringify({
          image_base64: imageBase64,
          date_str: formatDate(selectedDate) // ✅ Send date string to backend
        }),
      });

      if (response.status === 401) {
        localStorage.removeItem('tensor-auth-token');
        localStorage.removeItem('tensor-user-id');
        navigate('/', { state: { message: 'Session expired please try again.', type: 'error' } });
        return;
      }

      const result = await response.json();
      if (result.success) {
        setData(result.data.recommendations);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Failed to send screenshot or fetch data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Trigger on date change
  useEffect(() => {
    if (selectedDate) {
      setLoading(true);
      captureAndSendScreenshot();
    }
  }, [selectedDate]);

  return (
    <div className="w-full relative">
      {loading && (
        <div className="flex justify-center items-center min-h-[140px]">
          <svg className="w-6 h-6 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
            <path className="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
            </path>
          </svg>
        </div>
      )}

      {!loading && (
        <div className="min-h-[140px] max-h-[140px] overflow-y-auto">
          <p className="text-xl font-semibold mb-4 block_head">Recommendations By AI</p>
          <ul className="text-gray-600 space-y-2 ai_text">
            {data.map((item, index) => (
              <li key={index} className="flex items-start">
                <span className="flex items-center justify-center min-w-[1.75rem] h-6 px-2 text-white bg-[#0011BA] rounded-full mr-3 text-sm font-semibold text-center">
                  {index + 1}
                </span>
                <p>{item}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
